"use client";

import { useState, useEffect } from "react";

const useSticky = (stickyOffset = 100) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > stickyOffset);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [stickyOffset]);

  return isSticky;
};

export default useSticky;
